var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "bg-white py-8 border-b-2 border-gray-300" }, [
      _c(
        "div",
        { staticClass: "w-full md:w-10/12 mx-auto flex justify-between" },
        [
          _c(
            "div",
            { staticClass: "flex w-full flex-col justify-center items-start" },
            [
              _c("div", { staticClass: "flex items-center" }, [
                _c("div", { staticClass: "flex-1" }, [
                  _c("img", {
                    staticClass: "rounded-full h-20 mr-6",
                    attrs: { src: _vm.$store.getters.tokenInfo.picture }
                  })
                ]),
                _c("div", { staticClass: "flex-1" }, [
                  _c("h2", { staticClass: "font-bold text-2xl" }, [
                    _vm._v(_vm._s(_vm.$store.state.loggedInUser.name))
                  ]),
                  _c("h3", { staticClass: "text-xl text-gray-600 mr-5" }, [
                    _vm._v(_vm._s(_vm.$store.state.loggedInUser.email))
                  ])
                ])
              ]),
              _c(
                "router-link",
                {
                  staticClass:
                    "flex items-center mt-8 bg-white hover:bg-white -ml-2 py-2 pl-3 pr-4 text-gray-900 font-semibold border hover:border-gray-400 border-white rounded hover:shadow",
                  attrs: { to: "/" }
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "fill-current mr-2 h-5 w-5",
                      attrs: { viewBox: "0 0 24 24" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
                        }
                      })
                    ]
                  ),
                  _c("span", { staticClass: "uppercase text-sm" }, [
                    _vm._v("Back to home")
                  ])
                ]
              )
            ],
            1
          )
        ]
      )
    ]),
    _c("section", { staticClass: "py-8" }, [
      _c("div", { staticClass: "w-full md:w-10/12 mx-auto flex flex-col" }, [
        _vm.isDisabled
          ? _c(
              "div",
              {
                staticClass:
                  "border-l-4 border-blue-500 bg-blue-100 text-blue-800 py-5 mb-5 rounded pl-4"
              },
              [
                _vm._v(
                  "You cannot change your details as you logged in with a Social Provider. In order to change these details you must change then with the provider."
                )
              ]
            )
          : _vm._e(),
        _c("h2", { staticClass: "text-2xl font-semibold mb-5" }, [
          _vm._v("Profile")
        ]),
        _c(
          "div",
          { staticClass: "rounded shadow bg-white p-8 flex flex-col" },
          [
            _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "flex-1 mr-3" }, [
                _c(
                  "label",
                  {
                    staticClass:
                      "inline-block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3",
                    attrs: { for: "name" }
                  },
                  [_vm._v("Name")]
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name"
                    }
                  ],
                  staticClass:
                    "appearance-none block w-full disabled:bg-gray-200 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:cursor-not-allowed",
                  attrs: { id: "name", type: "text", disabled: _vm.isDisabled },
                  domProps: { value: _vm.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    }
                  }
                })
              ]),
              _c("div", { staticClass: "flex-1 ml-3" }, [
                _c(
                  "label",
                  {
                    staticClass:
                      "inline-block uppercase tracking-wide text-gray-700 text-xs font-bold mb-3",
                    attrs: { for: "email" }
                  },
                  [_vm._v("Email")]
                ),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass:
                    "appearance-none block w-full disabled:bg-gray-200 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:cursor-not-allowed",
                  attrs: { id: "email", type: "text", disabled: "" },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "flex flex-row-reverse mt-8" }, [
              _c(
                "button",
                {
                  staticClass:
                    "bg-green-200 hover:bg-green-300 text-green-900 font-semibold border border-green-400 rounded hover:shadow disabled:bg-green-500 disabled:cursor-not-allowed disabled:opacity-50",
                  attrs: { disabled: _vm.isDisabled || _vm.buttonLoading },
                  on: { click: _vm.saveProfile }
                },
                [
                  !_vm.buttonLoading
                    ? _c(
                        "div",
                        { staticClass: "inline-flex items-center py-2 px-4" },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "fill-current h-5 2-5 mr-2",
                              attrs: { viewBox: "0 0 24 24" }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"
                                }
                              })
                            ]
                          ),
                          _c("span", [_vm._v("Save")])
                        ]
                      )
                    : _vm._e(),
                  _vm.buttonLoading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "inline-flex items-center py-2 px-10 text-white"
                        },
                        [
                          _c("span", {
                            staticClass: "mdi mdi-loading mdi-spin"
                          })
                        ]
                      )
                    : _vm._e()
                ]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }